import React, { useState, useRef, useEffect, useCallback } from 'react';
import { FaSearch } from 'react-icons/fa';
import styles from '../style/TableFilter.css';

// Stable style objects defined outside the component to avoid recreation on every render
const filterStyles = {
    container: {
        position: 'relative',
        display: 'inline-block',
        marginLeft: '5px',
    },
    popup: {
        position: 'absolute',
        top: '100%',
        right: 0,
        backgroundColor: 'white',
        border: '1px solid #ddd',
        borderRadius: '4px',
        padding: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        zIndex: 1000,
        minWidth: '150px',
    },
};

const TableFilter = React.memo(({ column, type, options, onFilter }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [filterValue, setFilterValue] = useState('');
    const filterRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (filterRef.current && !filterRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const handleFilter = (e) => {
        const value = e.target.value;
        setFilterValue(value);
        onFilter(column, value);
    };

    const handleInputClick = (e) => {
        e.stopPropagation();
    };

    const handleInputMouseDown = (e) => {
        e.stopPropagation();
    };

    const clearFilter = () => {
        setFilterValue('');
        onFilter(column, '');
    };

    const renderFilterInput = () => {
        switch (type) {
            case 'select':
                return (
                    <div className="radio-container">
                        {options.map((option) => (
                            <div key={option.value} className="radio-item">
                                <label>
                                    <input
                                        type="radio"
                                        name={column}
                                        value={option.value}
                                        checked={filterValue === option.value}
                                        onChange={(e) => handleFilter(e)}
                                        onClick={handleInputClick}
                                        onMouseDown={handleInputMouseDown}
                                    />
                                    <span className="radio-label">{option.label}</span>
                                </label>
                            </div>
                        ))}
                        {filterValue && (
                            <button onClick={clearFilter} className="clear-filter">
                                Filtreyi Kaldır
                            </button>
                        )}
                    </div>
                );
            case 'date':
                return (
                    <div className="filter-input-container">
                        <input
                            type="date"
                            value={filterValue}
                            onChange={handleFilter}
                            onClick={handleInputClick}
                            onMouseDown={handleInputMouseDown}
                            className="filter-input"
                        />
                        {filterValue && (
                            <button onClick={clearFilter} className="clear-filter">
                                Filtreyi Kaldır
                            </button>
                        )}
                    </div>
                );
            default:
                return (
                    <div className="filter-input-container">
                        <input
                            type="text"
                            value={filterValue}
                            onChange={handleFilter}
                            onClick={handleInputClick}
                            onMouseDown={handleInputMouseDown}
                            placeholder="Ara..."
                            className="filter-input"
                        />
                        {filterValue && (
                            <button onClick={clearFilter} className="clear-filter">
                                Filtreyi Kaldır
                            </button>
                        )}
                    </div>
                );
        }
    };

    return (
        <div className="table-filter" ref={filterRef} style={filterStyles.container}>
            <FaSearch
                onClick={() => setIsOpen(!isOpen)}
                className={`${styles.filterIcon} ${isOpen ? styles.active : ''}`}
            />

            {isOpen && (
                <div className="filter-popup" style={filterStyles.popup} onClick={handleInputClick} onMouseDown={handleInputMouseDown}>
                    {renderFilterInput()}
                </div>
            )}
        </div>
    );
});

TableFilter.displayName = 'TableFilter';

export default TableFilter;
